(() => {
  const gal = document.querySelector('[data-mgal]');
  if (!gal) return;
  const track  = gal.querySelector('[data-mgal-track]');
  const slides = [...track.children];
  const thumbs = [...gal.querySelectorAll('[data-mgal-thumb]')];
  const counter = gal.querySelector('[data-mgal-counter]');
  const dotsBox = gal.querySelector('[data-mgal-dots]');
  const next = gal.querySelector('[data-mgal-next]');
  let idx = 0;

  const n = slides.length;
  dotsBox.innerHTML = '<span class="m-gal-bar"></span>';
  const bar = dotsBox.firstChild;
  bar.style.width = (100 / n) + '%';

  const stickyThumb = document.querySelector('#pdp-sticky-atc .pdp2-sticky-atc__thumb img');

  const setActive = (i) => {
    idx = i;
    counter.textContent = `${i + 1} / ${slides.length}`;
    bar.style.transform = 'translateX(' + (i * 100) + '%)';
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    // garde la mini-vignette de la barre « Ajouter au panier » synchro avec l'image affichée
    if (stickyThumb) {
      const im = slides[i] && slides[i].querySelector('img');
      if (im) stickyThumb.src = im.currentSrc || im.src;
    }
  };
  const goTo = (i) => track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });

  let raf;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== idx && slides[i]) setActive(i);
    });
  }, { passive: true });

  next.addEventListener('click', () => goTo(Math.min(idx + 1, slides.length - 1)));
  thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));

  // ── Sync clic Couleur (opkk) → la galerie mobile montre la photo du coloris ──
  // 1) par media-id (data-driven, fiable pour tous les produits)
  // 2) repli : nom du coloris = segment avant « — » de l'alt, en ignorant « worn- »
  const slideMediaId = slides.map((s) => s.getAttribute('data-media-id') || '');
  const slideInfo = slides.map((s) => {
    const im = s.querySelector('img');
    const alt = (im ? im.alt || '' : '').toLowerCase();
    return { seg: alt.replace('worn-', '').split('—')[0].trim(), worn: alt.includes('worn') };
  });
  const segEndsWith = (seg, val) => seg === val || seg.endsWith(' ' + val);
  const findSlideForColor = (btn) => {
    const mid = btn.getAttribute('data-media-id') || '';
    if (mid) {
      const h = slideMediaId.findIndex((s) => s && s === mid);
      if (h >= 0) return h;
    }
    const val = (btn.getAttribute('data-value') || '').toLowerCase().trim();
    if (!val) return -1;
    let hit = slideInfo.findIndex((s) => !s.worn && segEndsWith(s.seg, val));
    if (hit < 0) hit = slideInfo.findIndex((s) => segEndsWith(s.seg, val));
    if (hit < 0) hit = slideInfo.findIndex((s) => !s.worn && s.seg.includes(val));
    return hit;
  };
  // Saut instantané pour que la photo du coloris apparaisse aussitôt
  const jumpTo = (i) => { track.scrollTo({ left: slides[i].offsetLeft, behavior: 'auto' }); setActive(i); };
  [...document.querySelectorAll('.opkk-color, .pdp2-sw')].forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = findSlideForColor(btn);
      if (i >= 0) jumpTo(i);
    });
  });
  // Alignement initial sur le coloris actif
  const initActive = document.querySelector('.opkk-color.is-active, .pdp2-sw.is-active');
  if (initActive) {
    const i = findSlideForColor(initActive);
    if (i > 0) jumpTo(i);
  }
})();
